import React, {useState} from 'react';
import {CustomInput, FormGroup, Input} from "reactstrap";
import NumberFormat from "react-number-format";
import {DEPENDENT_RELATION_CHILD, DEPENDENT_RELATION_SPOUSE} from "../constants/generic";
import ReactTooltip from "react-tooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";

const Dependent = ({onChange, onDelete, dependent, requireFacility, deletable}) => {
    const [key] = useState(Math.random().toString(36).substring(2, 15));

    const setValue = (field, value) => {
        const d = {...dependent, [field]: value};

        onChange(d);
    };

    return (
        <React.Fragment>
            <div className="mb-4">
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>First Name *</label>
                            <Input type="text"
                                   id="first-name"
                                   value={dependent.first_name}
                                   onChange={e => {
                                       setValue("first_name", e.target.value);
                                   }}
                                   required
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Middle Name</label>
                            <Input type="text"
                                   id="middle-name"
                                   value={dependent.middle_name}
                                   onChange={e => {
                                       setValue("middle_name", e.target.value);
                                   }}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Last Name *</label>
                            <Input type="text"
                                   id="last-name"
                                   value={dependent.last_name}
                                   onChange={e => {
                                       setValue("last_name", e.target.value);
                                   }}
                                   required
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <FormGroup>
                            <label>Birthdate *</label>
                            <NumberFormat
                                value={dependent.birthdate}
                                customInput={Input}
                                allowEmptyFormatting
                                mask="_"
                                format="##/##/####"
                                onValueChange={values => {
                                    setValue("birthdate", values.formattedValue);
                                }}
                                required
                            />
                        </FormGroup>
                    </div>
                    {!!requireFacility &&
                    <div className="col-md-2">
                        <FormGroup id="tooltip-facility">
                            <label data-tip="When enrolling in an HMO plan, you need to choose a specific primary care provider."
                                   data-effect="solid"
                            >
                                Facility <FontAwesomeIcon icon={faInfoCircle}/>
                            </label>
                            <Input type="text"
                                   id="facility"
                                   value={dependent.facility || ""}
                                   onChange={e => {
                                       setValue("facility", e.target.value);
                                   }}
                            />
                        </FormGroup>
                    </div>}
                    <div className="col-md-4">
                        <div className="child-spouse-wrapper">
                            <CustomInput type="radio"
                                         id={`${key}-spouse`}
                                         label="Spouse"
                                         checked={dependent.relation === DEPENDENT_RELATION_SPOUSE}
                                         onChange={() => {
                                             setValue("relation", DEPENDENT_RELATION_SPOUSE)
                                         }}
                                         inline
                            />
                            <CustomInput type="radio"
                                         id={`${key}-child`}
                                         label="Child"
                                         checked={dependent.relation === DEPENDENT_RELATION_CHILD}
                                         onChange={() => {
                                             setValue("relation", DEPENDENT_RELATION_CHILD)
                                         }}
                                         inline
                            />
                        </div>
                    </div>
                </div>
                {deletable && <button type="button" className="btn btn-danger btn-sm" onClick={onDelete}>Delete</button>}
            </div>

            <ReactTooltip/>
        </React.Fragment>
    );
};

export default Dependent;
